import Transition, { type TransitionProps } from './transition';

export type FadeProps = Omit<TransitionProps, 'transitionClasses'>;

function Fade(props: FadeProps) {
  return (
    <Transition
      {...props}
      timeout={props.timeout ?? 600}
      transitionClasses={{
        base: 'transition-opacity ease-in-out',
        enter: 'opacity-100',
        exit: 'opacity-0',
      }}
    />
  );
}

Fade.displayName = 'GooeyFade';

export default Fade;
